import { postFacturasExportExcel } from "api/Factura.service"
import { TipoDocumentoComercialType } from "api/Types/TipoDocumentoComercial"
import { handleDirectDownloadExcel } from "common/context/DownloadFileProvider"
import { TFunction } from "i18next"
import { Dispatch, SetStateAction } from "react"

export interface ModalShowFacturaDetail {
  show: boolean
  id: string | null | undefined
  serie: string | null
}
export const handlerExportFacturasToExcel = async (
  tipoDocumentoComercial: TipoDocumentoComercialType,
  setIsLoadingExport: Dispatch<SetStateAction<boolean>>,
  t: TFunction
) => {
  try {
    setIsLoadingExport(true)
    const { data } = await postFacturasExportExcel({ tipoDocumentoComercial })
    handleDirectDownloadExcel(data, `${t("types.invoce")}.xlsx`)
    setIsLoadingExport(false)
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err)
  }
}
